import { ListType, THEME_CONSTANTS } from '@woolworthsnz/styleguide';
import { ListEndPointArgs } from '../../models/ListEndPointArgs';
export class StampSettings {
	static apiUrl = '';
	// eslint-disable-next-line @typescript-eslint/naming-convention
	static BASEURL = '/api/v1/';
	static endpoints = {
		productDetails: 'products',
		shopperNotes: 'shoppers/my/preferences',
		savedList: 'shoppers/my/saved-lists',
		trolley: 'trolleys',
	};
	static breakpoints = THEME_CONSTANTS.breakpoints;
	static constants = THEME_CONSTANTS;
	static listEndpoint = ({ listId, sku, listType }: ListEndPointArgs): string => {
		switch (listType) {
			case ListType.SavedList:
				return `${StampSettings.BASEURL}shoppers/my/${listType}/${listId}/items/${sku}`;
			case ListType.Favourites:
				return `${StampSettings.BASEURL}shoppers/my/${listType}/items/${sku}`;
			default:
				throw new Error(`Unsupported list type: ${listType}.`);
		}
	};
}
